import { toFiniteFirst } from '@cornerstonejs/utils';
export function compare(a, b) {
    if (a == b) {
        return 0;
    }
    if (!a && b) {
        return -1;
    }
    if (!b && a) {
        return 1;
    }
    return a < b ? -1 : 1;
}
export function compareSOPInstanceUID(a, b, _context) {
    return compare(String(a.SOPInstanceUID ?? a.imageId ?? ''), String(b.SOPInstanceUID ?? b.imageId ?? ''));
}
export function compareInstanceNumber(a, b, _context) {
    const aNumber = toFiniteFirst(a.InstanceNumber);
    const bNumber = toFiniteFirst(b.InstanceNumber);
    return aNumber !== undefined && bNumber !== undefined
        ? aNumber - bNumber
        : Number(aNumber === undefined) - Number(bNumber === undefined);
}
export function sortByInstanceNumber(a, b, context) {
    return (compareInstanceNumber(a, b, context) || compareSOPInstanceUID(a, b, context));
}
export const instancesSortCriteria = {
    default: sortByInstanceNumber,
    sortByInstanceNumber,
};
export function sortInstancesCopy(instances, criteria = instancesSortCriteria.default, context) {
    return [...instances].sort((a, b) => criteria(a, b, context));
}
